<template>
  <BaseModal ref="modal" v-model="modalShow" size="lg">
    <form @submit.prevent="onSubmit">
      <div class="row">
        <div class="form-group col-6">
          <label for="nameInput">Nombre de la evaluación</label>
          <input type="text" class="form-control" id="nameInput" v-model="name" required>
        </div>
      </div>
      <hr class="my-2">
      <ListEdit
        v-model="modelValue"
        label="Preguntas de la evaluación"
        @handleAdd="addQuestion"
        @handleRemove="removeQuestion"
        :minItems="1"
      >
        <template #default="{ index }">
          <div class="d-flex row me-1">
            <div class="col-sm-6 mb-2">
              <label for="descriptionInput">
                <b> Pregunta {{ index + 1 }} </b>
              </label>
              <textarea
                v-model="modelValue[index].description"
                class="form-control form-control-sm"
                id="descriptionInput"
                placeholder="Descripción de la pregunta"
                rows="4"
                required
              />
            </div>
            <div class="col-sm-6">
              <div>
                <label for="lastNameInput">Tipo</label>
                <select
                  v-model="modelValue[index].type"
                  class="form-select form-select-sm"
                  id="select-age-group"
                  @change="handleTypeChange($event, index)"
                  required
                >
                  <option :value="null" disabled selected>-- Selecciona un tipo de denuncia --</option>
                  <option v-for="questionType in questionTypes"
                    :key="questionType.id"
                    :value="questionType.id"
                    :label="questionType.name"
                  />
                </select>
              </div>

              <div class="mt-1">
                <BooleanQuestion
                  v-if="modelValue[index].type === 'bool'"
                  :question="modelValue[index]"
                  @input="handleOptionsInput($event, index)"
              
                />
                <SingleChoiceQuestion
                  v-else-if="modelValue[index].type === 'select'"
                  :question="modelValue[index]"
                  @input="handleOptionsInput($event, index)"
                />
              </div>
            </div>


          </div>
          <hr v-if="index < modelValue.length - 1">
        </template>

      </ListEdit>

      <div class="d-flex row align-items-center">
        <div class="col-4">
          <button type="submit" class="btn btn-primary" :disabled="isUploading">
            <b-spinner v-if="isUploading" small></b-spinner>
            Añadir evaluación
          </button>
        </div>
        <div class="col-sm flex-grow-1">
              <AlertDismiss ref="alert"/>
        </div>
      </div>
    </form>
  </BaseModal>
</template>

<script>
import ListEdit from '@/components/shared/List-edit.vue';
import BooleanQuestion from '../CurriculumForm/CurriculumAssesment-form.vue/Boolean-question.vue';
import SingleChoiceQuestion from '../CurriculumForm/CurriculumAssesment-form.vue/Single-choice-question.vue';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import {EventNames} from '@/plugins/enums/index.js'
import BaseModal from '@/components/shared/Base-modal.vue';
import { mapActions } from 'vuex';

export default {
  name: 'EvaluationForm',

  components: {
    ListEdit,
    BooleanQuestion,
    SingleChoiceQuestion,
    AlertDismiss,
    BaseModal
  },

  data() {
    return {
      modelValue: [],
      questionTypes: [
        {
          id: 'bool',
          name: 'Verdadero / Falso'
        },
        {
          id: 'select',
          name: 'Selección única'
        }
      ],

      modalShow: false,
      isUploading: false,
      name: null,
      curriculumId: null,
      courseId: null,
    }
  },

  mounted() {
      this.$eventBus.$on(EventNames.OpenEvaluationFormModal, ({curriculumId, courseId}) => {
        this.modalShow = true
        this.curriculumId = curriculumId
        this.courseId = courseId
      })
  },

  methods: {
    ...mapActions(["addEvaluation"]),
    async onSubmit() {

      this.isUploading = true

      let questions = this.modelValue.map(q => {
        let answers = q.options.map(o => {
          return { correctAnswer: o.isCorrect, text: o.label }
        })

        return { text: q.description, answers }
      })

      let payload = { name: this.name, questions, themeId: this.curriculumId }

      let result = await this.addEvaluation(payload)

      if (result.isError) {
        this.$refs.modal.showAlert(result.message, 'warning'),
          this.isUploading = false
        return
      }

      this.$refs.modal.showAlert('Evaluación añadida correctamente', 'success')
        this.$eventBus.$emit(EventNames.UpdateCurrentCurriculum, {courseId: this.courseId})
      this.reset()
      this.isUploading = false
    },

    reset() {
      this.modelValue = []
      this.name = null
      this.addQuestion()
    },

    addQuestion() {
      this.modelValue.push({
        description: null,
        type: null,
        options: null,
      });
    },

    removeQuestion(index) {
      this.modelValue.splice(index, 1);
    },

    handleOptionsInput(value, index) {
      this.$set(this.modelValue, index, value)
    },

    handleTypeChange(event, index) {
      // reset options
      this.$set(this.modelValue[index], 'options', [])
    }
  },

  watch: {
    modalShow: {
      handler(val) {
        if (!val) this.reset()
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
hr {
  margin-top: 0rem;
  margin-bottom: 0.5rem;
}
</style>
